import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {
  H6,
  Styles,
  FlexRow,
  FlexBaseCol,
  Icon as ToolkitIcon
} from '@contently/toolkit';

const Heading = styled(H6)`
  font-family: ${Styles.fonts.sans.family};
  font-weight: ${Styles.fonts.sans.weight.bold};
  font-size: ${Styles.fonts.sans.size.xlarge};
  color: ${Styles.colors.black};
  line-height: 1.4;
  margin-bottom: 6px;
  padding-top: 66px;
  text-transform: capitalize;
`;

const Icon = styled(ToolkitIcon)`
  width: 22px;
  height: 22px;
  font-size: 14px;
  line-height: 22px;
  padding-right: 5px;
`;

const EditorContainer = styled('div')`
  padding-left: 27px;
`;

const FieldRow = styled(FlexRow)`
  margin: 10px 0 16px 0;
  border-top: 1px solid ${Styles.colors.grey.secondaryDark};
`;

const FieldCol = styled(FlexBaseCol)`
  margin: 0 auto;
  padding: 0 20px;
  max-width: 720px;
`;

const fieldType = PropTypes.shape({
  assetPresent: PropTypes.bool.isRequired,
  assetId: PropTypes.number,
  id: PropTypes.number.isRequired,
  storyId: PropTypes.number.isRequired,
  assetUrl: PropTypes.string,
  assetName: PropTypes.string,
  name: PropTypes.string.isRequired
});

export {
  EditorContainer,
  FieldCol,
  FieldRow,
  Heading,
  Icon,
  fieldType
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/customFields/helpers.jsx